import React from 'react'
import FieldView from "../../../../fields3/render/view";
// import {FIELDS} from "../../../../fields2/fields.const"

export default function GListDefaultTitleFieldComponent(props: {
    field       : any,
    model       : any,
    module      : any // gList module
    onChange    : any
}) {
    /*switch (props.field.type) {
        case FIELDS.STRING  :
        case FIELDS.DATE    :
        case FIELDS.USER    : return props.field.renderView(props.model)

        default             :
            const column = props.module.columns.get(props.field.fieldId)
            return props.field[column.r__enderMethod](props.model, props.onChange)
    }*/

    return <FieldView field={props.field} model={props.model} />
}